import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const Button = ({ size, width, styleType, className, children, ...props }) => {
  const buttonComponents = {
    long: LongButton,
    medium: MediumButton,
  };

  const ButtonComponent = buttonComponents[width] || ButtonWrapper;

  return (
    <ButtonComponent
      className={className}
      type='button'
      styleType={styleType}
      size={size}
      width={width}
      {...props}
    >
      {children}
    </ButtonComponent>
  );
}

export default styled(Button)``;

Button.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(['xlarge', 'large', 'medium', 'small']),
  width: PropTypes.oneOf(['long', 'short', 'medium']),
  styleType: PropTypes.oneOf(['primary', 'secondary', 'disabled', 'rounded', 'icon']),
};

Button.defaultProps = {
  size: 'medium',
  width: 'short',
  styleType: 'primary'
};

const roundedStyles = css`
  border-radius: 50%;

  ${p => p.size === 'small' && css`
    width: 20px;
    height: 20px;
    padding: 0;

    .lizzy-icon {
      width: 12px;
      height: 12px;
    }
  `}
`;

const disabledStyle = css`
  background-color: var(--lizzy-black-10);
  color: var(--lizzy-black-65);
  border: 1px solid transparent;

  &:hover {
    background-color: var(--lizzy-black-35);
  }
`;

const primaryStyle = css`
  color: var(--lizzy-white);
  background-color:  var(--lizzy-blue);
  border: 1px solid var(--lizzy-blue);

  &:hover {
    background-color: var(--lizzy-blue-65);
    border: 1px solid var(--lizzy-blue-65);
  }
`;

const iconStyle = css`
  background-color: transparent;
  padding: 0;
  border: none;

  &:hover {
    background-color: transparent;
    border: none;
    color: var(--lizzy-black);
  }
`;

const secondaryStyle = css`
  background-color: var(--lizzy-white);
  border: 1px solid var(--lizzy-black-65);
  color: var(--lizzy-black-65);

  &:hover {
    border: 1px solid transparent;
    background-color: var(--lizzy-blue);
    color: var(--lizzy-white);
  }
`;

const lizzyIconsOverrides = css`
  .lizzy-icon {
    
  }
`;

const ButtonWrapper = styled.button`
  all: unset;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 18px 32px;
  border: 1px solid var(--lizzy-black);
  background-color: var(--lizzy-white);
  border-radius: 5px;
  color: var(--lizzy-black);
  text-align: center;
  cursor: pointer;

  &:hover {
    border: 1px solid transparent;
    background-color: var(--lizzy-blue);
    color: var(--lizzy-white);
  }

  ${p => p.styleType === 'primary' && primaryStyle}
  ${p => p.styleType === 'secondary' && secondaryStyle}
  ${p => p.styleType === 'disabled' && disabledStyle}
  ${p => p.styleType === 'rounded' && roundedStyles}
  ${p => p.styleType === 'icon' && iconStyle}

  &:disabled {
    ${disabledStyle}
  }

  ${p => p.size === 'small' && css`
    padding: 2px 18px;
    font-size: 14px;
    font-weight: 600;
  `}

  ${lizzyIconsOverrides}
`;

const LongButton = styled(ButtonWrapper)`
  padding: 4px 0;
  min-width: 316px;
`;

const MediumButton = styled(ButtonWrapper)`
  padding: 14px 0;
  min-width: 194px;
`;